import * as types from './types'

export default {
  [types.SET_LOCATION] (state, location) {
    let _logoBase64 = null
    if (location.logo !== null) {
      _logoBase64 = 'data:' + location.logoContentType + ';base64,' + location.logo
    }
    state.location = {
      id: location.id,
      accountNumber: location.accountNumber,
      name: location.name,
      timeZone: location.timeZone,
      stateID: location.stateID,
      logo: [],
      logoBase64: _logoBase64
    }
  },
  [types.SET_STATES] (state, states) {
    state.states = states || []
  },
  [types.SET_LOCATIONS] (state, locations) {
    state.locations = locations || []
  },
  [types.ADD_LOCATION] (state, location) {
    state.locations.push(location)
  },
  [types.DELETE_LOCATION] (state, location) {
    state.locations.splice(state.locations.indexOf(location), 1)
  },
  [types.RESET_LOCATION] (state) {
    state.location = {
      id: 0,
      accountNumber: null,
      name: null,
      timeZone: null,
      stateID: null,
      /**
       * This is where the file selected in the input is stored
       * @type {Array} - Array of File() objects
       */
      logo: [],
      /**
       * This is only used when we get data from the API.
       * @example "image/png"
       */
      logoContentType: null,
      /**
       * File converted as base64. Used to display the image in DOM
       */
      logoBase64: null
    }
  },
  [types.SET_KPI_STATS] (state, kpiStats) {
    state.kpiStats = kpiStats
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/location/mutations.js